import React from "react";

const ProductFocus = props => (
  <svg viewBox="0 0 20 21" fill="none" {...props}>
    <path
      d="M10 4.094c-3.555 0-6.406 2.89-6.406 6.406A6.385 6.385 0 0010 16.906c3.516 0 6.406-2.851 6.406-6.406 0-3.516-2.89-6.406-6.406-6.406zm0 11.562A5.151 5.151 0 014.844 10.5c0-2.813 2.304-5.156 5.156-5.156 2.813 0 5.156 2.343 5.156 5.156 0 2.852-2.344 5.156-5.156 5.156zm0-8.281A3.11 3.11 0 006.875 10.5c0 1.758 1.367 3.125 3.125 3.125a3.11 3.11 0 003.125-3.125A3.134 3.134 0 0010 7.375zm0 5A1.851 1.851 0 018.125 10.5c0-1.016.82-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875 0 1.055-.86 1.875-1.875 1.875zM10 .812C4.648.813.312 5.188.312 10.5A9.686 9.686 0 0010 20.188c5.313 0 9.688-4.336 9.688-9.688 0-5.313-4.375-9.688-9.688-9.688zm0 18.125A8.402 8.402 0 011.562 10.5 8.427 8.427 0 0110 2.062c4.648 0 8.438 3.79 8.438 8.438A8.427 8.427 0 0110 18.938z"
      fill="currentColor"
      fillOpacity={0.3}
    />
  </svg>
);

export default ProductFocus;
